export const sortingOptions = Object.freeze({
	RECENT_VIEW: { name: 'RECENT_VIEW', desc: '최근 조회 순'},
	LOWER_PRICE: { name: 'LOWER_PRICE', desc: '낮은 가격 순'}
});

export const localStorageTitle = Object.freeze({
	NOT_INTERESTED: { name: 'NOT_INTERESTED', desc:'관심없는 상품목록'},
	RECENT_INQUIRY_HISTORY: { name: 'RECENT_INQUIRY_HISTORY', desc: '최근 조회이력'}
})